import React, { useMemo } from 'react';
import styled from 'styled-components';

import Typography from 'antd/es/typography';

import { Row, Col } from 'components/layout';

import useSearcher from 'hooks/useSearcher';
import { useLocationSelect } from 'hooks/useSelect';
import useQueryParam from 'hooks/useQueryParam';
import useIndividualsChecked from 'hooks/useIndividualsChecked';

import MainLayout from 'layouts/Main.layout';
import PageHeader from 'components/MainPageHeader';
import Grid from 'components/Grid';
import Table from 'components/Table';
import StatsCard from 'components/StatsCard';
import FilterBar from 'components/FilterBar';
import Search from 'components/Search';

const IndividualsLivePageHeader = styled(PageHeader)`
  & .ant-page-header-content {
    padding-top: unset;
  }
`;

const CheckedIndividuals = () => {
  const locationSelect = useLocationSelect();
  const [searchVal, setSearchVal] = useQueryParam('s', '');

  const {
    isLoading,
    stats,
    summary = {},
  } = useIndividualsChecked(locationSelect.value);

  const searcher = useSearcher([
    'full_name',
  ]);

  const checkedEmployeesResults = useMemo(() => {
    const { checkins = [] } = stats.state.stats;
    searcher.setData(checkins);
    return searcher.search(searchVal);
  }, [searcher, stats.state.stats, searchVal]);

  return (
    <MainLayout>
      <IndividualsLivePageHeader
        title="Checked-in Individuals"
        icon="users"
        subTitle={null}
      >
        <Typography.Text style={{ fontSize: '12px', lineHeight: '20px', color: '#A4B0BA', marginLeft: '45px' }}>
          {summary.lastUpdate ? `Refreshed at: ${summary.lastUpdate}` : ''}
        </Typography.Text>
      </IndividualsLivePageHeader>
      <Grid gutter={24} columns={3} style={{ padding: '8px 24px 16px' }}>
        <StatsCard
          title="Individuals registered in current shift"
          value={summary.registeredIndividuals}
          titleAlign={['center', 'bottom']}
        />
        <StatsCard
          title="Current shift start time"
          value={summary.shiftStart}
          valueStyle={{
            fontSize: '20px',
            fontWeight: 500,
          }}
          titleAlign={['center', 'bottom']}
        />
        <StatsCard
          title="Current shift end time"
          value={summary.shiftEnd}
          valueStyle={{
            fontSize: '20px',
            fontWeight: 500,
          }}
          titleAlign={['center', 'bottom']}
        />
      </Grid>

      <Row style={{ padding: '12px 24px', width: '100%' }}>
        <FilterBar
          title="Individuals"
          style={{ width: '100%' }}
        >
          <FilterBar.Slot align="right">
            <Search placeholder="Search individual" value={searchVal} onChange={setSearchVal} />
          </FilterBar.Slot>
        </FilterBar>
      </Row>

      <Row style={{ padding: '12px 24px' }}>
        <Col span={24}>
          <Table pagination={{ showSizeChanger: false }}
            dataSource={checkedEmployeesResults}
            loading={isLoading}
            rowKey={'employee_id'}
          >
            <Table.Column type="link" title="Individual" dataIndex="full_name" to={({ item }) => `/individuals/${item.employee_id}`} />
            <Table.Column type="text" title="Code" dataIndex="tag" />
            <Table.Column type="datetime" title="Check-in time" dataIndex="valid_from" tzOffset="timezone_offset" />
          </Table>
        </Col>
      </Row>
    </MainLayout>
  );
};

export default CheckedIndividuals;